import script from "./adjustments-modal-loading-rows.vue?vue&type=script&lang=ts&setup=true"
export * from "./adjustments-modal-loading-rows.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__